<template>

    <form
        @submit.prevent="handleSubmit"
        @keydown.enter.prevent="handleSubmit"
    >
        <input-component
            class="w-full"
            type="text"
            v-model="form.code"
            ref="twoFactorInput"
            autofocus
            required
            :input-label="recoveryMode ? $t('auth.recovery_code') : $t('auth.auth_code')"
        />

        <div v-if="hasErrors" class="mt-8 self-start">
            <ul class="text-semantic-error text-body-sm">
                <li v-for="(error, index) in allErrors" :key="index" class="flex items-center">
                    <svg-icon type="warning" class="max-w-12 max-h-12 mr-4"></svg-icon>
                    <span>{{ error }}</span>
                </li>
            </ul>
        </div>

        <simple-button
            class="w-full mt-24"
            :disabled="!form.code"
            display="secondary"
            :loading="form.submitting"
            look="primary"
            type="submit"
        >
            {{ confirmText }}
        </simple-button>

        <simple-button
            v-if="allowRecoveryMode"
            class="w-full"
            look="text"
            @click.prevent="toggleRecoveryMode"
        >
            {{ recoveryMode ? $t('auth.use_auth_code') : $t('auth.use_recovery_code') }}
        </simple-button>

    </form>
</template>

<script>
import Form from '../../etc/forms/Form';
import Input from '../forms/Input.vue';
import SimpleButton from './SimpleButton.vue';
import values from 'lodash/values';
import flatten from 'lodash/flatten';
import * as users from '../../services/UserService';
import visitIntended from '../../etc/VisitIntended';
import {mapActions} from 'pinia';
import {useAuthenticationStore} from '../../state/modules/authentication';
import SvgIcon from './SvgIcon.vue';

export default {
    props: {
        largerText: Boolean,
    },
    components: {
        'input-component': Input,
        'simple-button': SimpleButton,
        'svg-icon': SvgIcon,
    },
    data: function () {
        return {
            confirmText: this.$t('two_factor_config.verify'),
            allowRecoveryMode: false,
            recoveryMode: false,
            form: new Form([
                {name: 'code', value: '', rules: []},
            ]),
            redirectAfterLogin: null,
        }
    },
    computed: {
        hasErrors() {
            return values(this.form.errors).some(errors => errors !== undefined);
        },
        allErrors() {
            return flatten(values(this.form.errors).filter(error => error && error.length));
        },
    },
    methods: {
        ...mapActions(useAuthenticationStore, ['setUser']),
        handleSubmit() {
            this.form.submit(data => users.twoFactorVerify({
                [this.recoveryMode ? 'recovery_code' : 'authentication_code']: data.code
            }))
            .then(response => {
                this.$emit('code-valid')
            })
            .catch(() => {
            });
        },
    },
}
</script>
